<template>
    <div class="yh-page">
        <el-card>
            <el-collapse v-model="activeNames">
            <el-collapse-item title="基础信息" name="1">
            <el-form ref="form" :model="form" :validate-on-rule-change="false" label-position="right"
                label-width="160px" >
                <div class="container">
                    <div class="left">
                        <el-divider content-position="left">基础信息</el-divider>
                        <el-col :span="15">
                            <el-form-item label="抵扣船舶名">
                                <el-input type="text" v-model="form.deduction_ship_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="所属会员">
                                <el-input type="text" v-model="form.member_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>

                        <el-col :span="15">
                            <el-form-item label="所属活动">
                                <el-input type="text" v-model="form.activity_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="被抵扣账户船名">
                                <el-input type="text" v-model="form.ship_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>

                        <el-col :span="18">
                            <el-form-item label="抵扣类型">
                                <el-input type="text" v-model="form.type_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>

                        <el-col :span="18">
                            <el-form-item label="创建人">
                                <el-input type="text" v-model="form.creator_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="申请状态">
                                <el-input type="text" v-model="form.status_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>

                        <el-col :span="18">
                            <el-form-item label="抵扣风险准备金金额">
                                <el-input type="number" v-model="form.risk_premium" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="抵扣活动费金额">
                                <el-input type="number" v-model="form.insurance_premium" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="本次不允许开票金额">
                                <el-tooltip class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        因前期已开票，故本次不再允许开票
                                    </div>
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                                <el-input type="number" v-model="form.no_invoice" style="width: 46%;" :disabled="opera_type != 'ApplyAdjust'"/>
                            </el-form-item>
                        </el-col>

                        <el-col :span="18">
                            <el-form-item label="调差金额">
                                <el-col :span="23">
                                <el-table :key="0" :data="form.diff_account" stripe fit class="w-100">

                                <el-table-column align="left" label="账户id" width="70px">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.id}}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column align="left" label="船名" width="120px">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.ship_name}}</span>
                                    </template>
                                </el-table-column>
                                
                                <el-table-column align="left" label="账户余额">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.balance}}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column align="left" label="超额金额">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.excess_balance}}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column align="left" label="申请抵扣金额">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.deduction_account}}</span>
                                    </template>
                                </el-table-column>

                                
                                <el-table-column align="left" label="上期缴费总吨">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.pay_gross_ton}}</span>
                                    </template>
                                </el-table-column>
                        
                                <!-- <el-table-column align="left" label="船名">
                                    <template slot-scope="scope">
                                    <span>{{scope.row.ship_name}}</span>
                                    </template>
                                </el-table-column> -->
                                <el-table-column align="left" label="调差金额">
                                    <template slot-scope="scope">
                                        <el-input type="number" v-model="scope.row.diff_account" :max="scope.row.deduction_account" :disabled="opera_type !== 'ApplyAdjust'" />
                                    </template>
                                    
                                </el-table-column>

                                </el-table>
                                </el-col>
                            </el-form-item>
                        </el-col>

                        <el-col :span="18">
                            <el-form-item label="财务备注">
                                <el-input type="textarea"  :rows="4" v-model="form.remark" style="width: 48%;" :disabled="opera_type !== 'ApplyAdjust'" />
                            </el-form-item>
                        </el-col>


                        <el-col :span="18">
                            <el-form-item label="业管备注">
                                <el-input type="textarea"  :rows="4" v-model="form.refuse_reason" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <!-- 身份证明文件 -->
                            <el-form-item label="申请文件" prop="attachments">
                            <attachment-list 
                                object-type="member.member" :object-id="form.id" :file-list="file_list"
                                :attachment-name="attachment_name"
                                @removed="loadFileList('group_insurance.insurancedeductionapply', form.id)"></attachment-list>
                            <el-button type="primary" size="small" @click="handleUpload" class="ml-2">上传</el-button>
                            </el-form-item>
                        </el-col>

                    </div>
                </div>
            </el-form>
            <!--创建按钮-->
            <div class="btn-box">
                <el-button type="primary" @click="handleSuccess" v-if="opera_type === 'ApplySuccess'">审核通过</el-button>
                <el-button type="primary" @click="handleReject" v-if="opera_type === 'ApplySuccess'">审核不通过</el-button>
                <!-- <el-button type="primary" @click="handleBusinessSuccess" v-if="opera_type === 'BusinessAuditing'">审核通过</el-button>
                <el-button type="primary" @click="handleBusinessReject" v-if="opera_type === 'BusinessAuditing'">审核不通过</el-button> -->
                <el-button type="primary" @click="handleUpdate" v-if="opera_type === 'ApplyAdjust'">确认调整</el-button>
                <el-button type="primary" @click="handleRefuse" v-if="opera_type === 'ApplyAdjust'">拒绝申请</el-button>
                <el-button @click="() => {this.$router.go(-1)}">返回列表</el-button> 
            </div>
            </el-collapse-item>
            <el-collapse-item title="相关文书" name="2">
                        <el-col>
                            <file-sign-list :attachments="file_list" object_type="group_insurance.insurancedeductionapply" :object_id="form.customer_id
"></file-sign-list>
                         </el-col>
            </el-collapse-item>
            <upload-dialog ref="upload" :object-name="form.ship_name" :file-type-list="file_type_list"
                object-type="group_insurance.insurancedeductionapply" :object-id="form.id" :append-to-body="true"
                :default-issue-date.sync="default_issue_date" 
                @appended="handleAppended" @uploaded="loadFileList('group_insurance.insurancedeductionapply', form.id)">
            </upload-dialog>
            <el-dialog :visible.sync="SuggestionVisible" width="50%">
                <el-form ref="refuse_reason" :model="refuse_reason" label-width="120px">
                <el-form-item label="备注" width="50%">
                    <el-input type="textarea"  :rows="10" v-model="refuse_reason"></el-input>
                </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="RefuseDeductionApply" v-show="result === 2">确认拒绝</el-button>
                <el-button type="primary" @click="addMessage" v-show="result === 0">确认拒绝</el-button>
                <el-button type="primary" @click="successDeduction" v-show="result === 1">确认通过</el-button>
                <el-button type="primary" @click="businessQuitShipApply" v-show="result === 5">确认通过</el-button>
                <el-button type="primary" @click="businessRefuseQuitShipApply" v-show="result === 6">确认拒绝</el-button>
                </span>
            </el-dialog>
        </el-collapse>
        </el-card>
    </div>
</template>
<script>

import UploadDialog from "@/components/UploadDialog"
import { getDeductionApply,successDeductionApply,failDeductionApply,financeDeductionFailApply,updateDeductionApply,businessRejectApply,businessSuccessApply } from '@/api/group-insurance'
import { fetchFileTypeList, getObjectFileAll } from '@/api/common'
import AttachmentList from "@/components/AttachmentList"
import FileSignList from '@/components/FileSignListDetail'




export default {
    name: "deductionApplyDetail",
    components: {
        UploadDialog,
        AttachmentList,
        FileSignList

    },
    computed: {
        attachment_name: function () {
        let name = this.form.ship_name
        return (name + ".zip");
        }
    },
    data() {
        return {
            ship_name:"",
            member:"",
            creator:"",
            apply_time:"",
            result:null,
            default_issue_date: '',
            file_type_list: [],
            activeNames: ["1", "2"],
            file_list: [],
            is_member:true,
            form:{
                'id':"",
                'no_invoice': 0
            },
            apply_info:{},
            opera_type:"",
            SuggestionVisible:false,
            refuse_reason:"",
            loadingText: '正在加载数据，请稍等...',
        };
    },

    methods: { 
        businessRefuseQuitShipApply(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                businessRejectApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'DeductionApplyList' })  
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        businessQuitShipApply() {
            var msg = '是否通过该申请？'
            this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
            }).then(() => {
                businessSuccessApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                this.$message({
                    type: 'success',
                    message: '通过成功!'
                })
                this.$router.push({ name: 'DeductionApplyList' })  
                this.refuse_reason = ""
                })
                .catch(error => {
                this.$message.error(error)
                this.is_member = false
                })
            })
            },
        handleUpdate(){
            let account_list = this.form.diff_account
            let count_list = []
            account_list.forEach(item => {
                    if (item.diff_account > item.deduction_account){
                        count_list.push(item.ship_name)
                    }
                })
            if (count_list.length > 0){
                this.$error_message("调差金额不能大于申请抵扣金额！")
                    return
            }
            updateDeductionApply({"id":this.id,'data':this.form}).then(resp => {
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                    })
                this.$router.push({ name: 'DeductionApplyList' })  
                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
        },
        getData(id){
            getDeductionApply({"id":id}).then(resp => {
                this.form = resp

                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
        },
        handleAppended(fileList) {
            this.file_list = this.file_list.concat(fileList)
            },
        loadFileList(object_type, object_id) {
            getObjectFileAll(object_type, object_id).then(res => {
                this.file_list = res
                this.file_list.forEach(item => {
                    this.$set(item, 'checked', true)
                })
            })
            .catch(error => {
                this.$error_message(error)
            })
        },
        handleUpload() {
            this.$refs.upload.handleOpen()
            },
        RefuseDeductionApply(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                financeDeductionFailApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'DeductionApplyList' })   
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
       
        addMessage(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                failDeductionApply({'id':this.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'DeductionApplyList' })   
                    this.refuse_reason = ""
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        handleRefuse() {
            this.SuggestionVisible = true
            this.result = 2
        },
        handleReject() {
            this.SuggestionVisible = true
            this.result = 0
        },
        handleSuccess() {
            this.SuggestionVisible = true
            this.result = 1
        },
        handleFinanceSuccess() {
            this.SuggestionVisible = true
            this.result = 3
        },
        handleFinanceReject() {
            this.SuggestionVisible = true
            this.result = 4
        },
        handleBusinessSuccess() {
            this.SuggestionVisible = true
            this.result = 5
        },
        handleBusinessReject() {
            this.SuggestionVisible = true
            this.result = 6
        },
        successDeduction() {
          var msg = '是否通过该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            successDeductionApply({'id':this.id,'refuse_reason':this.refuse_reason})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '通过成功!'
                })
                this.$router.push({ name: 'DeductionApplyList' }) 
                this.refuse_reason = ""
              })
              .catch(error => {
                this.$message.error(error)
                this.is_member = false
              })
          })
        },
        loadData() {
            this.getData(this.id)
            console.log(this.form)
            if (this.opear_type  !== 'ApplySuccess'){
                this.loadFileList('group_insurance.insurancedeductionapply', this.id)
            }
            
            let p0 = fetchFileTypeList({ file_type: "bc" })
            Promise.all([p0])
                .then(res => {
 
                this.file_type_list = res[0]

                })
                .catch(error => {
                this.loading = false
                this.$message.error(error)
                })
                },
        
     
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'DeductionApplyList') {
            window.localStorage.removeItem('query')
        }
        next()
    },
    created() {
        this.opera_type = this.$route.query.type
        console.log(this.opera_type)
        this.id = this.$route.query.id
        
       
        this.loadData()
        // console.log(this.id )
    },
};
</script>

